import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { SHORTCUT_LIST } from '../hooks/useKeyboardShortcuts';
import { useMemo } from 'react';

export const ShortcutsHelp = ({ open, onClose }) => {
  // Pre-group shortcuts by section once — SHORTCUT_LIST is a module-level const.
  const grouped = useMemo(() => {
    const out = {};
    for (const s of SHORTCUT_LIST) {
      (out[s.section] = out[s.section] || []).push(s);
    }
    return Object.entries(out);
  }, []);

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-[92vw] sm:max-w-2xl p-0" data-testid="shortcuts-help-dialog">
        <DialogHeader className="px-5 pt-5 pb-0">
          <DialogTitle className="text-base font-semibold">Keyboard Shortcuts</DialogTitle>
        </DialogHeader>
        <div className="overflow-y-auto max-h-[65vh] px-5 pb-5 pt-3">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-4">
            {grouped.map(([section, items]) => (
              <div key={section}>
                <p className="text-[10px] font-bold text-muted-foreground uppercase tracking-widest mb-1.5 border-b border-border/60 pb-1">{section}</p>
                <div className="space-y-0">
                  {items.map(s => (
                    <div key={s.key} className="flex items-center justify-between py-[5px] group">
                      <span className="text-[13px] text-foreground/75 leading-tight">{s.label}</span>
                      <kbd className="ml-3 shrink-0 min-w-[2rem] text-center px-1.5 py-0.5 text-[11px] font-mono bg-muted/70 border border-border/80 rounded text-muted-foreground">
                        {s.key}
                      </kbd>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
